'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideModal = exports.showModal = undefined;
var _constants = require('./constants');

/**
 * The action that must be dispatced to show a modal
 * @param {string} component This is the identifier passed to the Modal component
 * @param {number} offset Optional vertical position to restore the screen at after closing the modal
 */
var showModal = exports.showModal = function showModal(component) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var data = arguments[2];
  return {
    type: _constants.actionTypes.SHOW_MODAL,
    component: component,
    scrollY: typeof offset === 'undefined' ? window.scrollY : offset,
    data: data
  };
};
var hideModal = exports.hideModal = function hideModal() {
  return {
    type: _constants.actionTypes.HIDE_MODAL
  };
};